import { createBlueprint as e } from "@made-people/blueprint";
const s = e({
  slots: {
    wrapper: "relative z-0 my-[var(--spacing-y)]",
    container: "w-full justify-center items-center flex-col box-border gap-4 md:gap-6 lg:gap-8",
    listWrapper: "relative w-full h-full",
    list: "",
    header: "w-full flex justify-between items-end px-[var(--header-spacing-x)]",
    linkWrapper: "data-[placement=footer]:order-1",
    link: "",
    linkBelowList: "data-[placement=footer]:order-1 px-[var(--linkbelowlist-spacing-x)]"
  },
  variants: {
    size: {
      sm: {
        container: ""
      },
      md: {
        container: ""
      },
      lg: {
        container: ""
      }
    },
    layout: {
      stacked: {
        wrapper: "",
        container: "grid grid-cols-[1fr_max-content]",
        header: "justify-between items-end",
        listWrapper: "col-span-2",
        linkWrapper: "px-[var(--header-spacing-x)] self-end",
        linkBelowList: "px-[var(--linkbelowlist-spacing-x)] self-end"
      },
      inline1: {
        wrapper: "",
        container: "grid-cols-[1fr_66.66%]",
        listWrapper: "col-start-2 col-end-3 row-start-1 row-end-3"
      },
      inline2: { wrapper: "" }
    },
    background: {
      none: {
        wrapper: ""
      },
      surface: {
        wrapper: "bg-background-surface-1 py-4 md:py-6 lg:py-8"
      },
      white: {
        wrapper: "bg-white py-4 md:py-6 lg:py-8"
      }
    }
  },
  defaultVariants: {
    background: "white"
  }
}), a = {
  wrapper: "absolute top-0 left-0 w-full h-full pointer-events-none",
  rightArrow: "pointer-events-auto absolute right-[calc(var(--spacing-x)*2)] top-1/2 -translate-y-1/2 z-30 disabled:scale-0 scale-100 transition-all p-3 bg-white rounded-full border border-black active:scale-105",
  leftArrow: "pointer-events-auto absolute left-[calc(var(--spacing-x)*2)] top-1/2 -translate-y-1/2 z-30 disabled:scale-0 scale-100 transition-all p-3 bg-white rounded-full border border-black active:scale-105"
}, p = {
  leftOffset: {
    gutter: {
      wrapper: "",
      rightArrow: "",
      leftArrow: "left-[calc(var(--spacing-x)*2)]"
    },
    edge: {
      wrapper: "",
      rightArrow: "",
      leftArrow: "left-0"
    }
  },
  rightOffset: {
    gutter: {
      wrapper: "",
      rightArrow: "right-[calc(var(--spacing-x)*2)]",
      leftArrow: ""
    },
    edge: {
      wrapper: "",
      rightArrow: "right-0",
      leftArrow: ""
    }
  },
  color: {
    white: {
      wrapper: "",
      rightArrow: "",
      leftArrow: ""
    },
    surface: {
      wrapper: "",
      rightArrow: "",
      leftArrow: ""
    }
  }
}, t = e({
  slots: a,
  variants: p,
  defaultVariants: {
    leftOffset: "gutter",
    rightOffset: "gutter",
    color: "white"
  }
}), i = e({
  slots: {
    wrapper: "flex justify-center gap-2 data-[can-scroll=false]:hidden",
    dot: "block w-2.5 h-2.5 rounded-full data-[active=true]:rounded-full bg-neutral-100 hover:bg-white-60 data-[active=true]:bg-primary data-[active=true]:cursor-default transition-all m-0",
    listItem: ""
  },
  variants: {}
}), n = e({
  slots: {
    wrapper: "w-full data-[can-scroll=false]:hidden bg-black/20",
    progressBar: "w-full h-1 bg-[#D9F38D]"
  },
  variants: {}
}), l = e({
  slots: {
    wrapper: "absolute top-0 w-full p-4",
    numbers: ""
  },
  variants: {}
}), c = e({
  slots: {
    wrapper: "bg-black/20 w-full h-1 rounded-xl w-96 m-auto",
    scrollbarThumb: "bg-black rounded-xl"
  },
  variants: {}
}), o = e({
  slots: {
    wrapper: "w-full px-[var(--spacing-x)]"
  },
  variants: {}
}), g = e({
  slots: {
    wrapper: "flex py-2 ml-[var(--list-margin-left)] mr-[var(--list-margin-right)] w-auto gap-[var(--gap)] pl-[var(--list-padding-left)] pr-[var(--list-padding-right)] scroll-pl-[var(--list-padding-left)] scroll-pr-[var(--list-padding-right)] snap-mandatory snap-x overflow-x-scroll overflow-y-visible box-border group/swiper",
    // wrapper:
    //   "py-2 flex w-full gap-[var(--gap)] px-[var(--list-spacing-x)] scroll-px-[var(--list-spacing-x)] snap-mandatory snap-x overflow-x-scroll overflow-y-visible box-border group/swiper",
    item: "w-[calc((100%-(var(--gap)*(var(--items-in-view)-1)))/var(--items-in-view))] grow-0 shrink-0 snap-start overflow-y-visible transition-all"
  },
  variants: {}
}), w = e({
  slots: {
    wrapper: "my-[var(--spacing-y)]",
    maxWidthWrapper: "",
    listWrapperVars: "",
    headerWrapperVars: "",
    linkBelowListWrapperVars: ""
  },
  variants: {
    y: {
      none: { wrapper: "[--spacing-y:0px" },
      "5xs": { wrapper: "[--spacing-y:theme(space.component-spacing-5xs)]" },
      "4xs": { wrapper: "[--spacing-y:theme(space.component-spacing-4xs)]" },
      "3xs": { wrapper: "[--spacing-y:theme(space.component-spacing-3xs)]" },
      "2xs": { wrapper: "[--spacing-y:theme(space.component-spacing-2xs)]" },
      xs: { wrapper: "[--spacing-y:theme(space.component-spacing-xs)]" },
      sm: { wrapper: "[--spacing-y:theme(space.component-spacing-sm)]" },
      md: { wrapper: "[--spacing-y:theme(space.component-spacing-md)]" },
      lg: { wrapper: "[--spacing-y:theme(space.component-spacing-lg)]" },
      xl: { wrapper: "[--spacing-y:theme(space.component-spacing-xl)]" },
      "2xl": { wrapper: "[--spacing-y:theme(space.component-spacing-2xl)]" },
      "3xl": { wrapper: "[--spacing-y:theme(space.component-spacing-3xl)]" },
      "4xl": { wrapper: "[--spacing-y:theme(space.component-spacing-4xl)]" },
      "5xl": { wrapper: "[--spacing-y:theme(space.component-spacing-5xl)]" },
      "6xl": { wrapper: "[--spacing-y:theme(space.component-spacing-6xl)]" },
      "7xl": { wrapper: "[--spacing-y:theme(space.component-spacing-7xl)]" }
    },
    x: {
      none: { wrapper: "[--spacing-x:0px]" },
      "5xs": { wrapper: "[--spacing-x:theme(space.component-spacing-5xs)]" },
      "4xs": { wrapper: "[--spacing-x:theme(space.component-spacing-4xs)]" },
      "3xs": { wrapper: "[--spacing-x:theme(space.component-spacing-3xs)]" },
      "2xs": { wrapper: "[--spacing-x:theme(space.component-spacing-2xs)]" },
      xs: { wrapper: "[--spacing-x:theme(space.component-spacing-xs)]" },
      sm: { wrapper: "[--spacing-x:theme(space.component-spacing-sm)]" },
      md: { wrapper: "[--spacing-x:theme(space.component-spacing-md)]" },
      lg: { wrapper: "[--spacing-x:theme(space.component-spacing-lg)]" },
      xl: { wrapper: "[--spacing-x:theme(space.component-spacing-xl)]" },
      "2xl": { wrapper: "[--spacing-x:theme(space.component-spacing-2xl)]" },
      "3xl": { wrapper: "[--spacing-x:theme(space.component-spacing-3xl)]" },
      "4xl": { wrapper: "[--spacing-x:theme(space.component-spacing-4xl)]" },
      "5xl": { wrapper: "[--spacing-x:theme(space.component-spacing-5xl)]" },
      "6xl": { wrapper: "[--spacing-x:theme(space.component-spacing-6xl)]" },
      "7xl": { wrapper: "[--spacing-x:theme(space.component-spacing-7xl)]" }
    },
    gap: {
      none: { wrapper: "[--gap:0px]" },
      "5xs": { wrapper: "[--gap:theme(space.component-spacing-5xs)]" },
      "4xs": { wrapper: "[--gap:theme(space.component-spacing-4xs)]" },
      "3xs": { wrapper: "[--gap:theme(space.component-spacing-3xs)]" },
      "2xs": { wrapper: "[--gap:theme(space.component-spacing-2xs)]" },
      xs: { wrapper: "[--gap:theme(space.component-spacing-xs)]" },
      sm: { wrapper: "[--gap:theme(space.component-spacing-sm)]" },
      md: { wrapper: "[--gap:theme(space.component-spacing-md)]" },
      lg: { wrapper: "[--gap:theme(space.component-spacing-lg)]" },
      xl: { wrapper: "[--gap:theme(space.component-spacing-xl)]" },
      "2xl": { wrapper: "[--gap:theme(space.component-spacing-2xl)]" },
      "3xl": { wrapper: "[--gap:theme(space.component-spacing-3xl)]" },
      "4xl": { wrapper: "[--gap:theme(space.component-spacing-4xl)]" },
      "5xl": { wrapper: "[--gap:theme(space.component-spacing-5xl)]" },
      "6xl": { wrapper: "[--gap:theme(space.component-spacing-6xl)]" },
      "7xl": { wrapper: "[--gap:theme(space.component-spacing-7xl)]" }
    },
    bleed: {
      true: {
        headerWrapperVars: "[--header-spacing-x:var(--spacing-x)] [--linkbelowlist-spacing-x:var(--spacing-x)]",
        listWrapperVars: "[--list-spacing-x:0px] [--list-padding-left:0px] [--list-padding-right:0px] [--list-margin-left:0px] [--list-margin-right:0px]",
        linkBelowListWrapperVars: "[--linkbelowlist-spacing-x:var(--spacing-x)]"
      },
      false: {
        headerWrapperVars: "[--header-spacing-x:var(--spacing-x)] [--linkbelowlist-spacing-x:var(--spacing-x)]",
        listWrapperVars: "[--list-margin-left:var(--spacing-x)] [--list-margin-right:var(--spacing-x)] [--list-padding-left:0px] [--list-padding-right:0px] @[100vw]:[--list-margin-left:0px] @[100vw]:[--list-margin-right:0px] @[100vw]:[--list-padding-left:var(--spacing-x)] @[100vw]:[--list-padding-right:var(--spacing-x)] ",
        linkBelowListWrapperVars: "[--linkbelowlist-spacing-x:var(--spacing-x)]"
      }
    },
    bleedLeft: {
      true: {
        listWrapperVars: "[--list-margin-left:0px] [--list-padding-left:0px] @[100vw]:[--list-margin-left:0px] @[100vw]:[--list-padding-left:0px]"
      },
      false: {
        listWrapperVars: ""
      }
    },
    bleedRight: {
      true: {
        listWrapperVars: "[--list-margin-right:0px] [--list-padding-right:0px] @[100vw]:[--list-margin-right:0px] @[100vw]:[--list-padding-right:0px]"
      },
      false: {
        listWrapperVars: ""
      }
    },
    maxWidth: {
      page: {
        maxWidthWrapper: "max-w-[calc(max(var(--component-max-width-xl-px),var(--component-max-width-xl))+(var(--spacing-x)*2))] ml-auto mr-auto"
      }
    }
  },
  compoundVariants: [
    {
      variants: { bleed: "false", x: "none" },
      slots: { wrapper: "" }
    }
  ],
  defaultVariants: {
    gap: "sm",
    x: {
      initial: "none",
      lg: "md"
    },
    bleed: "false",
    bleedLeft: "false",
    bleedRight: "false"
  }
}), m = e({
  slots: {
    item: "w-[calc((100%-(var(--gap)*(var(--items-in-view)-1)))/var(--items-in-view))] ",
    wrapper: ""
  },
  variants: {
    itemsInView: {
      auto: { item: "w-auto" },
      1: { wrapper: "[--items-in-view:1]" },
      "1.1": { wrapper: "[--items-in-view:1.1]" },
      "1.5": { wrapper: "[--items-in-view:1.5]" },
      2: { wrapper: "[--items-in-view:2]" },
      "2.1": { wrapper: "[--items-in-view:2.1]" },
      "2.5": { wrapper: "[--items-in-view:2.5]" },
      3: { wrapper: "[--items-in-view:3]" },
      "3.2": { wrapper: "[--items-in-view:3.2]" },
      "3.5": { wrapper: "[--items-in-view:3.5]" },
      4: { wrapper: "[--items-in-view:4]" },
      "4.2": { wrapper: "[--items-in-view:4.2]" },
      "4.5": { wrapper: "[--items-in-view:4.5]" },
      5: { wrapper: "[--items-in-view:5]" },
      6: { wrapper: "[--items-in-view:6]" }
    }
  }
});
export {
  m as swiperFunctionalityBlueprint,
  g as swiperListBlueprint,
  t as swiperNavigationBlueprint,
  o as swiperPaginationBlueprint,
  i as swiperPaginationDotsBlueprint,
  l as swiperPaginationNumbersBlueprint,
  n as swiperPaginationProgressBarBlueprint,
  c as swiperPaginationScrollBar,
  w as swiperSpacingBlueprint,
  s as swiperTemplate1Blueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
